const faqItems = [
  {
    q: '91黑料网的内容来源可靠吗？',
    a: '我们坚持多重核实原则，每条爆料在发布前都经过团队交叉验证。信息来源包括公开报道、行业内部人士、知情者投稿等。对于无法完全核实的内容，我们会标注"待核实"标签，让读者自行判断。',
  },
  {
    q: '如何在91黑料网投稿爆料？',
    a: '欢迎通过页面的投稿联系入口提交你的爆料信息。请提供尽可能详细的事件描述和相关证据材料，我们的编辑团队会在24小时内审核。优质爆料一经采用，将给予爆料者相应奖励和匿名保护。',
  },
  {
    q: '91黑料网的内容更新频率是怎样的？',
    a: '我们保持7×24小时全天候运营，编辑团队实时监控全网热点动态。平均每日更新超过50条吃瓜内容，重大事件15分钟内即可发布追踪报道，确保你永远站在吃瓜第一线。',
  },
  {
    q: '平台会保护爆料人的隐私吗？',
    a: '绝对会。我们深知爆料人安全的重要性，所有投稿均采用加密传输，爆料人身份信息严格保密。即使面对外部压力，我们也绝不会透露任何爆料人的个人信息，这是我们坚持了多年的底线。',
  },
  {
    q: '看到不实信息如何反馈？',
    a: '如果你发现平台内容存在事实错误，请通过投稿联系入口提交反馈，附上相关证据。我们的编辑团队会第一时间核实，确认有误的内容将在2小时内进行更正或下架，并在显著位置发布更正声明。',
  },
];

const carouselItems = [
  {
    id: 1,
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20of%20a%20magnifying%20glass%20over%20a%20dark%20newspaper%20with%20warm%20golden%20lighting%2C%20investigation%20concept%2C%20rich%20crimson%20and%20amber%20tones%2C%20professional%20photojournalism%20style&width=800&height=500&seq=carousel-01-91hl&orientation=landscape',
    tag: '深度专题',
    title: '2024娱乐圈翻车年鉴',
    desc: '盘点今年那些让人大跌眼镜的明星翻车瞬间',
  },
  {
    id: 2,
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20spotlight%20illuminating%20a%20dark%20empty%20room%20with%20floating%20dust%20particles%2C%20revelation%20concept%2C%20warm%20theatrical%20lighting%2C%20mysterious%20atmosphere%2C%20professional%20magazine%20aesthetic&width=800&height=500&seq=carousel-02-91hl&orientation=landscape',
    tag: '行业观察',
    title: '直播带货造假产业链',
    desc: '揭秘刷单、刷量、刷评背后的灰色利益链条',
  },
  {
    id: 3,
    img: 'https://readdy.ai/api/search-image?query=Professional%20editorial%20photography%20of%20cracked%20phone%20screen%20with%20dramatic%20backlighting%2C%20digital%20scandal%20concept%2C%20warm%20and%20dark%20contrasting%20tones%2C%20modern%20magazine%20style%2C%20cinematic%20composition&width=800&height=500&seq=carousel-03-91hl&orientation=landscape',
    tag: '独家调查',
    title: 'MCN机构黑幕全揭秘',
    desc: '合同陷阱、霸王条款、拖欠分成——网红经济的阴暗面',
  },
  {
    id: 4,
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20scene%20of%20scattered%20playing%20cards%20on%20dark%20velvet%20surface%2C%20one%20card%20under%20spotlight%2C%20secret%20revealed%20concept%2C%20warm%20crimson%20lighting%2C%20professional%20photography&width=800&height=500&seq=carousel-04-91hl&orientation=landscape',
    tag: '年度盘点',
    title: '综艺节目恶意剪辑大全',
    desc: '那些被后期毁掉的嘉宾和那些靠剪辑翻红的套路',
  },
  {
    id: 5,
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20broken%20chain%20link%20with%20warm%20backlighting%2C%20freedom%20from%20contracts%20concept%2C%20rich%20golden%20and%20charcoal%20tones%2C%20dramatic%20composition%2C%20professional%20news%20magazine%20aesthetic&width=800&height=500&seq=carousel-05-91hl&orientation=landscape',
    tag: '深度追踪',
    title: '网红解约潮背后的真相',
    desc: '今年已有超过200位签约主播集体出走，原因究竟是什么？',
  },
  {
    id: 6,
    img: 'https://readdy.ai/api/search-image?query=Professional%20editorial%20photography%20of%20a%20gavel%20and%20documents%20under%20dramatic%20lighting%2C%20legal%20battle%20concept%2C%20warm%20amber%20and%20deep%20shadows%2C%20courtroom%20aesthetic%2C%20magazine%20cover%20style%2C%20cinematic%20composition&width=800&height=500&seq=carousel-06-91hl&orientation=landscape',
    tag: '法律视角',
    title: '网络名誉权诉讼地图',
    desc: '2024年明星网红发起的名誉权案件同比增长了47%',
  },
];

export default function SectionsB() {
  return (
    <>
      {/* #app - 吃瓜社区入口 */}
      <section id="app" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="bg-background-100 rounded-3xl overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="flex-1 p-8 md:p-12 lg:p-16">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-bold mb-4 whitespace-nowrap">
                  吃瓜社区
                </span>
                <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-4">
                  加入吃瓜社区，一起深度讨论
                </h2>
                <p className="text-secondary-500 text-sm md:text-base leading-relaxed mb-6 max-w-lg">
                  百万吃瓜群众在线互动，热门话题实时讨论。在这里，你可以发表观点、分享线索、参与投票，
                  和志同道合的人一起深挖每一个瓜的背后故事。吃瓜，从来不是一个人的事。
                </p>
                <div className="flex flex-wrap gap-3 mb-6">
                  {['实时讨论', '匿名爆料', '投票吃瓜', '话题专区'].map((f) => (
                    <span key={f} className="flex items-center gap-1.5 text-xs text-secondary-500 whitespace-nowrap">
                      <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i> {f}
                    </span>
                  ))}
                </div>
                <a
                  href="#comments"
                  onClick={(e) => { e.preventDefault(); document.querySelector('#comments')?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-white font-bold text-sm whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-colors"
                >
                  <i className="ri-user-heart-line text-lg"></i>
                  进入吃瓜社区
                </a>
              </div>
              <div className="flex-1 w-full lg:w-auto">
                <div className="h-64 lg:h-96 w-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20digital%20community%20concept%20with%20overlapping%20conversation%20bubbles%20in%20warm%20amber%20and%20crimson%20tones%2C%20abstract%20social%20media%20interaction%20visualization%2C%20soft%20glowing%20elements%2C%20editorial%20magazine%20style%2C%20professional%20photography%20with%20shallow%20depth%20of%20field&width=800&height=600&seq=app-community-91hl&orientation=landscape"
                    alt="91黑料网吃瓜社区"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* #about - 关于我们 */}
      <section id="about" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-bold mb-4 whitespace-nowrap">
              关于我们
            </span>
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-6">
              全网最敢说的吃瓜平台
            </h2>
            <div className="text-secondary-500 text-sm md:text-base leading-relaxed space-y-4 text-left">
              <p>
                91黑料网成立于2020年，是国内领先的黑料吃瓜与爆料曝光内容平台。
                我们致力于为全网吃瓜群众提供最新、最全、最真实的黑料事件追踪与深度解读。
                从娱乐圈的八卦绯闻到商业圈的内幕交易，从网红圈的虚假宣传到科技圈的产品翻车，
                91黑料网的编辑团队始终坚持"说真话、爆真料"的初心。
              </p>
              <p>
                我们的团队由资深媒体人、调查记者和数据分析师组成，凭借专业的信息挖掘能力和严格的核实流程，
                已累计发布超过1000条独家爆料内容。平台日均活跃用户超过50万，月均产生超过200万条互动评论。
                91黑料网不仅是吃瓜群众的聚集地，更是推动行业透明化的重要力量。
              </p>
              <p>
                我们相信，阳光是最好的消毒剂。通过持续不断的爆料曝光与深度追踪，
                91黑料网让每一个值得关注的真相都能被看见、被讨论、被记住。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* #carousel - 焦点专题图文区 */}
      <section id="carousel" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-secondary-500 text-sm md:text-base max-w-xl mx-auto">
              精选深度专题内容，全方位解读热门黑料事件
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {carouselItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
              >
                <div className="relative h-52 md:h-64 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <span className="absolute bottom-4 left-4 px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-bold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-secondary-500">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* #faq - 常见问答 */}
      <section id="faq" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-secondary-500 text-sm md:text-base max-w-xl mx-auto">
              关于91黑料网，你想知道的都在这里
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-3">
            {faqItems.map((item, i) => (
              <details key={i} className="group bg-background-50 rounded-2xl overflow-hidden" open>
                <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer select-none">
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 pr-4">
                    {item.q}
                  </h3>
                  <span className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center shrink-0 group-open:rotate-45 transition-transform">
                    <i className="ri-add-line text-secondary-500"></i>
                  </span>
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm md:text-base text-secondary-500 leading-relaxed">
                  {item.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}